import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { TableRow } from "@mui/material"
import React, { type ReactElement } from "react"

interface DraggableRowProps {
  id: string
  children: (opts: { listeners?: SyntheticListenerMap }) => React.ReactNode
}

export const DraggableRow = ({ id, children, ...rowProps }: DraggableRowProps): ReactElement => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...(isDragging ? { opacity: 0.6 } : {}),
  }

  return (
    <TableRow ref={setNodeRef} style={style} {...attributes} {...rowProps}>
      {children({ listeners })}
    </TableRow>
  )
}
